module.exports = __webpack_public_path__ + "static/img/Alice.bbe8ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/ats/Alice.png
// module id = JSO4
// module chunks = 0